import React from 'react';
import ValidatedAutocomplete from '../ValidatedAutocomplete';
import useAdvisors from '../../resources/advisor/read';

const ServiceAdvisorAutocomplete = ({
  control,
  merchantId,
}) => {
  const { data: serviceAdvisors = [], isLoading } = useAdvisors(merchantId);

  return (
    <ValidatedAutocomplete
      name="advisorId"
      control={control}
      options={serviceAdvisors}
      isLoading={isLoading}
      inputLabel="Service Advisor"
      getOptionLabel={(o) => `${o.first_name} ${o.last_name}`}
    />
  );
};

export default ServiceAdvisorAutocomplete;
